import React from "react";

const C14Provider = () => {
  const Url = new URL("https://pay.c14.money");

  Url.searchParams.set("clientId", "b69a98b8-c5c1-4c7b-b5a9-46bca9a74480");
  Url.searchParams.set("mainColor", "222735");
  Url.searchParams.set("bgColor", "222735");
  Url.searchParams.set("sourceCurrencyCode", "USD");
  Url.searchParams.set("targetAssetId", "dee50e5c-3e78-4a0c-b794-0b97f5ee577e");

  return (
    <iframe
      src={Url}
      style={{
        marginTop: '40px',
        border: "0.5px solid #374151",
        outline: "none",
        width: "365px",
        height: "634px",
        borderRadius: "12px",
      }}
    />
  );
};

export default C14Provider;
